import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="px-6 md:px-10 lg:px-16 pb-10" data-testid="site-footer">
    <div className="border-t border-[#111111] pt-8 grid grid-cols-1 md:grid-cols-12 gap-8">
      <div className="md:col-span-4">
        <img src="/logo-sfr.png" alt="Sebastián Ferradás Rosso · Arquitecto" className="w-[110px] max-w-[110px] h-auto object-contain select-none" draggable="false" />
        <p className="mt-4 text-sm font-light text-[#111111]/70 max-w-xs">
          Arquitectura, diseño y gestión de proyectos.
        </p>
      </div>
      <div className="md:col-span-3 md:col-start-6 text-sm font-light flex flex-col items-start gap-[10px]">
        <Link to="/obras" className="ed-link" data-testid="footer-link-obras">Obras</Link>
        <a href="/#servicios" className="ed-link">Servicios</a>
        <a href="/#estudio" className="ed-link">Estudio</a>
        <a href="/#contacto" className="ed-link">Contacto</a>
      </div>
      <div className="md:col-span-3 md:col-start-10 text-sm font-light text-[#111111]/70">
        <p>Hotelería · Centros Comerciales · Vivienda</p>
        <p className="mt-4">© {new Date().getFullYear()} Ferradás Arquitectura</p>
      </div>
    </div>
  </footer>
);
